import Vue from "vue";
import DictionaryService from "../core/dictionary.service";

Vue.filter("t", (value: string, ...args: string[]) => {
    return DictionaryService.get(value, args);
});
